import React from "react";

import { TagType, _Tag } from "./_Tag";

export function NeutralTag({
  type = "bold",
  testID = "neutral-tag",
  ...props
}: TagType) {
  if (type === "bold")
    return (
      <_Tag
        fill="background-accent-neutral-strong"
        color="text-inverse"
        testID={testID}
        {...props}
      />
    );

  return (
    <_Tag
      fill="background-accent-neutral-weak"
      color="text-base"
      testID={testID}
      {...props}
    />
  );
}
